<template>
  <div class="page-login">
    <mod-web-header :title="$route.query.from === 'join' ? '入驻加盟' : '店管家登录'" />
    <div class="wrapper">
      <div class="mod-box clearfix">
        <form class="login-box" @submit.prevent="onLogin">
          <div class="tab clearfix">
            <span :class="$addClass('entry', [tabIdx === 0, 'on'])" @click="onTabChange"
              >用户密码登录</span
            >
            <span :class="$addClass('entry', [tabIdx === 1, 'on'])" @click="onTabChange"
              >手机动态码登录</span
            >
          </div>
          <div v-if="tabIdx === 0" class="user-input">
            <z-input
              v-model.trim="username"
              class="item"
              :width="282"
              placeholder="请输入主账号的手机号，或账号"
              @focus="onFocus('username')"
            />
            <p :class="$addClass('error', [!errors.username, 'hide'])">* {{ errors.username }}</p>
            <z-input
              v-model.trim="password"
              class="item"
              type="password"
              :width="282"
              placeholder="请输入6-20位字母和数字组合密码"
              @focus="onFocus('password')"
            />
            <p :class="$addClass('error', [!errors.password, 'hide'])">* {{ errors.password }}</p>
            <div v-if="img" class="item">
              <z-input
                v-model.trim="captcha"
                :width="162"
                placeholder="请输入右边验证码"
                @focus="onFocus('captcha')"
              />
              <img class="captchas" :src="img" @click="fetchCaptchas" />
            </div>
            <p v-if="img && !errorText" :class="$addClass('error', [!errors.captcha, 'hide'])">
              * {{ errors.captcha }}
            </p>
          </div>
          <div v-else class="user-input">
            <z-input
              v-model.trim="mobile"
              class="item"
              :width="282"
              placeholder="请输入手机号"
              @input="onMobileInput"
              @focus="onFocus('mobile')"
            />
            <p :class="$addClass('error', [!errors.mobile, 'hide'])">* {{ errors.mobile }}</p>
            <div class="item">
              <z-input
                v-model.trim="pin"
                :width="162"
                placeholder="请输入6位验证码"
                @focus="onFocus('pin')"
              />
              <z-verification :mobile="mobile" type="login" @error="onError" @success="onSuccess" />
            </div>
            <p v-if="pinSuccess" class="success-text">* {{ pinSuccess }}</p>
            <p v-if="!errorText && !pinSuccess" :class="$addClass('error', [!errors.pin, 'hide'])">
              * {{ errors.pin }}
            </p>
          </div>
          <p v-if="errorText" class="error-text">* {{ errorText }}</p>
          <p class="options clearfix">
            <label><z-checkbox v-model="remember" />7天自动登录</label>
            <a class="f-r" href="/password/reset">忘记密码</a>
          </p>
          <button class="submit-button" type="submit">登录</button>
        </form>
      </div>
    </div>
    <div v-if="$route.query.from === 'join'" class="mod-box">
      <div class="join-title">
        <h4>供应商入驻加盟流程</h4>
        <p>供应商通过下面的流程步骤，即可快速开设平台店铺</p>
      </div>
      <div class="step clearfix">
        <div v-for="(item, idx) in list" :key="item" class="item">
          <i class="icon" />
          <p>{{ item }}</p>
          <i v-if="idx < 3" class="next" />
        </div>
      </div>
      <div class="tab-nav clearfix">
        <span :class="$addClass('tab-item', [tab === 0, 'on'])" @click="onTabClick(0)"
          >招商方向</span
        >
        <span :class="$addClass('tab-item', [tab === 1, 'on'])" @click="onTabClick(1)"
          >资质要求</span
        >
        <span :class="$addClass('tab-item', [tab === 2, 'on'])" @click="onTabClick(2)"
          >资费标准</span
        >
      </div>
      <div v-if="tab === 0" class="tab-content"></div>
      <div v-if="tab === 1" class="tab-content"></div>
      <div v-if="tab === 2" class="tab-content"></div>
    </div>
    <mod-mobile-demo />
    <com-copyright />
  </div>
</template>

<script>
import ModWebHeader from '@/components/mod-web-header'
import ModMobileDemo from '@/components/mod-mobile-demo'
import ComCopyright from '@/components/com-copyright'
import ZVerification from '@/components/z-verification'
import { syncToken, setAccessToken, setUser, regExp } from '@/utils'
import { getCaptchas, login, loginByPin } from '@/data'

export default {
  name: 'Login',
  components: {
    ModWebHeader,
    ModMobileDemo,
    ComCopyright,
    ZVerification
  },
  data() {
    return {
      tab: 0,
      tabIdx: 0,
      img: '',
      username: '',
      password: '',
      mobile: '',
      pin: '',
      captcha: '',
      key: '',
      remember: false,
      errors: {},
      errorText: '',
      pinSuccess: '',
      list: [
        '注册平台账号,登录申请开店',
        '在线签订入驻协议',
        '在线提交商家资质信息',
        '平台审核开通，进入店铺管理'
      ]
    }
  },
  beforeMount() {
    document.title = '我要入驻 - 纵购商城'
  },
  methods: {
    onMobileInput() {
      this.mobile = this.mobile.substr(0, 11).replace(/[^0-9]/g, '')
    },
    onTabClick(idx) {
      this.tab = idx
    },
    onTabChange() {
      this.tabIdx = this.tabIdx === 0 ? 1 : 0
      // this.errors = {}
      // this.errorText = ''
    },
    onFocus(name) {
      const errors = { ...this.errors }
      errors[name] = ''
      this.errors = errors
      this.errorText = ''
      this.pinSuccess = ''
    },
    onError(error) {
      const errors = {}
      errors[error.field] = error.message
      this.errors = errors
      this.pinSuccess = ''
      this.errorText = ''
    },
    onSuccess(message) {
      this.errors = {}
      this.pinSuccess = message
      this.errorText = ''
    },
    goto(baseUrl, token) {
      let url = `${process.env.VUE_APP_SELLER_ORIGIN}${baseUrl}`
      const isIos = /(iPhone|iPod|iPad);?/i.test(navigator.userAgent.toLowerCase())
      if (isIos) url += `?token=${token}` // ios下不支持ifarme写入localStrage，所以需要传token

      window.location.href = url
    },
    async onLogin() {
      const { from } = this.$route.query
      const { tabIdx, username, password, mobile, pin, captcha, key, remember } = this
      let user,
        formData,
        errors = {}

      if (tabIdx === 0) {
        if (!username) {
          errors.username = '请输入正确的手机号或用户名'
        }

        // if (!regExp.MOBILE.test(username)) {
        //   errors.username = '请输入正确的手机号'
        // }

        // if (!password) {
        //   errors.password = '请输入密码'
        // }

        // if (!regExp.PASSWORD.test(password)) {
        //   errors.password = '请输入6-20位字母和数字组合密码'
        // }

        // if (key && !captcha) {
        //   errors.captcha = '请输入图片验证码'
        // }
      } else {
        if (!mobile) {
          errors.mobile = '请输入手机号'
        }

        if (!regExp.MOBILE.test(mobile)) {
          errors.username = '请输入正确的手机号'
        }

        // if (!pin) {
        //   errors.pin = '请输入验证码'
        // }
      }

      this.pinSuccess = ''

      if (Object.keys(errors).length > 0) {
        this.errors = errors
        return
      }

      if (tabIdx === 0) {
        formData = { username, password }
        if (key) {
          formData.key = key
          formData.captcha = captcha
        }
        if (remember) {
          formData.remember = '1'
        }
        user = await login(formData)
      } else {
        formData = { mobile, pin }
        if (remember) {
          formData.remember = '1'
        }
        user = await loginByPin(formData)
      }

      if (user.error_code === 0) {
        setUser(user)
        setAccessToken(user.token, user.expires_in)

        const token = user.seller_token
        if (token) {
          await syncToken(token)
        }

        if (new RegExp(process.env.VUE_APP_SELLER_ORIGIN).test(from)) {
          this.goto(from.replace(process.env.VUE_APP_SELLER_ORIGIN, ''), token)
          return
        }

        if (user.show_welcome === 0) {
          this.goto('', token)
          return
        }

        if (from === 'join') {
          this.$router.replace(`/join`)
          return
        }

        this.$router.replace('/')
      } else if (
        user.error_code === 6011 ||
        (user.errors && user.errors[0] && user.errors[0].field === 'captcha')
      ) {
        this.fetchCaptchas()
        this.errorText = user.message
      } else if (user.errors.length > 0) {
        user.errors.forEach((item) => {
          errors[item.field] = item.message
        })
      } else {
        this.errorText = user.message
      }

      this.errors = errors
    },
    async fetchCaptchas() {
      const { key, img } = await getCaptchas()

      if (img) {
        this.img = img
        this.key = key
      }
    }
  }
}
</script>

<style lang="postcss">
.page-login {
  .step {
    width: 920px;
    margin: 0 auto;
    padding: 10px 0;

    .item {
      float: left;
      width: 25%;
      text-align: center;
      position: relative;

      .icon,
      .next {
        display: inline-block;
        width: 50px;
        height: 50px;
        background: url('../assets/images/icon-s.png') no-repeat;
      }

      .icon {
        margin-bottom: 20px;
      }

      .next {
        display: inline-block;
        position: absolute;
        background-position: 0 -50px;
        width: 100px;
        height: 14px;
        top: 18px;
        left: 173px;
      }

      &:nth-child(2) .icon {
        background-position: -50px 0;
      }

      &:nth-child(3) .icon {
        background-position: -100px 0;
      }

      &:nth-child(4) .icon {
        background-position: -150px 0;
      }
    }
  }

  .join-title {
    text-align: center;
    padding: 30px 0;

    h4 {
      font-weight: normal;
      font-size: 28px;
      margin-bottom: 5px;
    }

    p {
      font-size: 12px;
    }
  }

  .tab-nav {
    margin-top: 30px;

    .tab-item {
      float: left;
      background-color: #fff;
      border: none;
      color: #515a6e;
      font-size: 14px;
      padding: 0 10px;
      height: 40px;
      line-height: 38px;
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
      width: 399px;
      text-align: center;
      border: 1px solid #dcdee2;

      &:first-child {
        border-right: none;
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-left: none;
        border-radius: 0 4px 4px 0;
      }

      &:hover {
        color: #57a3f3;
        background-color: #fff;
      }

      &.on {
        color: #fff;
        background-color: #2d8cf0;
        border-color: #2d8cf0;
      }
    }
  }

  .tab-content {
    padding: 20px 10px 30px 10px;
  }

  .wrapper {
    height: 520px;
    padding: 65px 0;
    background-color: #333;

    .mod-box {
      background: url(../assets/images/bg-login.png) no-repeat 10% center;
    }
  }

  .z-checkbox {
    margin-right: 5px;
    vertical-align: -3px;
  }

  .login-box {
    width: 332px;
    height: 390px;
    background-color: #fff;
    border-radius: 5px;
    margin-right: 45px;
    padding: 20px 0;
    float: right;

    .tab {
      line-height: 36px;

      .entry {
        text-align: center;
        width: 50%;
        float: left;
        border-bottom: 1px solid #ccc;
        cursor: pointer;
        color: #999;

        &.on {
          border-color: #333;
          color: #333;
        }
      }
    }

    .user-input {
      padding: 20px 25px 0 25px;

      .z-input {
        height: 38px;
        line-height: 28px;
      }
    }

    .item {
      margin-top: 10px;
      width: 100%;

      &.hide {
        visibility: hidden;
      }

      button {
        border: none;
        background-color: #ccc;
        height: 38px;
        font-size: 12px;
        color: #666;
        margin-left: 10px;
        width: 110px;
        border-radius: 5px;
        cursor: pointer;
      }

      .captchas {
        height: 38px;
        width: 110px;
        margin-left: 10px;
        border-radius: 5px;
      }
    }

    .options {
      font-size: 12px;
      margin: 15px 25px 0 25px;
    }

    .error,
    .error-text,
    .success-text {
      font-size: 12px;
      padding: 0 5px;
      color: #c81613;
      height: 18px;

      &.space {
        margin-top: 63px;
      }

      &.hide {
        visibility: hidden;
      }
    }

    .error-text {
      padding: 0 25px;
    }

    .success-text {
      color: #19be6b;
    }

    .submit-button {
      height: 44px;
      background-color: #fabe00;
      border: none;
      width: 280px;
      border-radius: 5px;
      font-size: 16px;
      color: #fff;
      margin: 15px 25px 0 25px;
      cursor: pointer;
    }
  }

  .mod-mobile-demo {
    background-color: #fdf9f8;
  }

  .com-copyright {
    background-color: #fff;
  }
}
</style>
